// TODO: RANGER TOUT LE DOSSIER MODELS COMME IL FAUT
import { Moment } from 'moment-timezone'
import { DAY_FORMAT, DAYTIME_FORMAT, TOO_MUCH_CHILDREN_ERROR } from './constants'
import moment from 'moment'

export function verifyConfirmedChildNumber(count: number, confirmedChildIds: number[]) {
    if (confirmedChildIds.length > count) throw new Error(TOO_MUCH_CHILDREN_ERROR)
}

export function momentDay(date?: string | Moment): Moment {
    return moment(date, DAY_FORMAT)
}

export function momentDaytime(date?: string | Moment | Date): Moment {
    return moment(date, DAYTIME_FORMAT)
}
